import { render, staticRenderFns } from "./ClickLinkSetting.vue?vue&type=template&id=769fd57c"
import script from "./ClickLinkSetting.vue?vue&type=script&lang=js"
export * from "./ClickLinkSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports